import React, { useEffect } from 'react';
import { InputTextArea } from '@brokerbay/elements-web';
import { AccessOptionProps } from '../../types';
import UploadEditPhotoButton from '../UploadEditPhotoButton';

const SupraEKey: React.FC<AccessOptionProps> = ({
  showingsConfig,
  listing,
  setShowingsConfig,
  setIsValid,
}) => {
  useEffect(() => {
    // always valid
    setIsValid(true);
  }, [setIsValid, showingsConfig]);

  return (
    <>
      <div>
        <UploadEditPhotoButton
          listingId={listing.id}
          lockboxPhoto={showingsConfig.lockboxPhoto}
          setLockboxPhoto={val => {
            setShowingsConfig(prev => ({
              ...prev,
              lockboxPhoto: val,
            }));
          }}
        />
      </div>
      <div>
        <InputTextArea
          label="Special Access Instructions"
          labelExtra="(optional)"
          dataCy="showing-notification-ekey-instructions"
          value={showingsConfig.instructions.supraekey?.details || ''}
          onChange={value =>
            setShowingsConfig(prev => ({
              ...prev,
              instructions: {
                ...prev.instructions,
                supraekey: {
                  ...(prev.instructions.supraekey || {}),
                  details: value,
                },
              },
            }))
          }
        />
      </div>
    </>
  );
};

export default SupraEKey;
